var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ns-popup", {
    ref: "popup",
    staticClass: "ns-opt-in",
    attrs: {
      closable: true,
      greeting: _vm.headName
        ? _vm.translate("signupGreeting", { name: _vm.headName })
        : "",
      "head-logo":
        "/content/dam/apps/loyalty/" +
        _vm.language +
        "_" +
        _vm.market +
        "/enJoy_nuskinrewards_white.svg"
    },
    on: { close: _vm.close },
    scopedSlots: _vm._u([
      {
        key: "pageIntroduction",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "c-body" },
              [
                _c("h2", { staticClass: "c-heading title-small-bold" }, [
                  _vm._v(_vm._s(_vm.translate("signupTitle")))
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "c-description p-medium tx-em-bold-800 tx-em-style-none"
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.translate("signupText"))
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("ns-checkbox", {
                  staticClass: "c-accept-checkbox",
                  attrs: { "box-color": "#6236FF" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function() {
                        return [
                          _c("div", {
                            staticClass: "input-text title-small-bold",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.translate("signupTermsAndConditions")
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.openTermsAndConditions($event)
                              }
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.agreeTermsAndConditions,
                    callback: function($$v) {
                      _vm.agreeTermsAndConditions = $$v
                    },
                    expression: "agreeTermsAndConditions"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "c-button-container" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "primary-solid fluid short bc-accept title-small-bold",
                      attrs: { disabled: !_vm.agreeTermsAndConditions },
                      on: {
                        click: function($event) {
                          return _vm.optIn()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.translate("signupJoinNow")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "primary-ghost fluid short bc-cancel title-small-bold",
                      on: {
                        click: function($event) {
                          return _vm.close("loyaltyModalCancel")
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.translate("signupCancel")))
                      ])
                    ]
                  )
                ])
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }